import { injectService } from '@patsnap/tahiti-core/ioc/inject';
import { AgentApi, type GenerateJobRequest } from '@/domains/agent/apis';
import { HomeMaterialApi } from '@/domains/home/apis/home-material-api';
import { ref } from 'vue';

export const useFindSolutions = () => {
  const homeMaterialApiService = injectService<HomeMaterialApi>(HomeMaterialApi);
  const agentApiService = injectService<AgentApi>(AgentApi);

  const findSolutionsAgentId = ref(0);
  const jobId = ref('');

  const getAgentId = async () => {
    if (!findSolutionsAgentId.value) {
      const oldProducts = await homeMaterialApiService.getProducts();
      findSolutionsAgentId.value =
        oldProducts.find((p) => p.function_id === 'find_solution_material_v2')?.agent_id || 0;
    }

    return findSolutionsAgentId.value;
  };

  async function createChatJob(input: string) {
    if (!jobId.value) {
      const payload: GenerateJobRequest = {
        input,
        agent_ids: [findSolutionsAgentId.value],
        team_ids: [],
      };

      jobId.value = (await agentApiService.chatJob(payload)).job_id;
    }

    window.location.href = `/ai/agent-flow/${jobId.value}`;
  }

  async function submitPipeline(input: string) {
    await getAgentId();
    await createChatJob(input);
  }

  return {
    submitPipeline,
  };
};
